import { render, staticRenderFns } from "./Units.vue?vue&type=template&id=3f5ff76c"
import script from "./Units.vue?vue&type=script&lang=js"
export * from "./Units.vue?vue&type=script&lang=js"
import style0 from "./Units.vue?vue&type=style&index=0&id=3f5ff76c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports